export enum EmailEntryMaxLengthsEnum {
  SUBJECT = 200,
  EMAIL_CONTENT = 5000,
}
